import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { isGPCoInvestPortal } from "@vega-core/utils/global";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CommonPaths } from "@vega-modules/paths";

import { DataRoomAndNdaPage } from "./DataRoomAndNdaPage";
import { DataRoomPage } from "./DataRoomPage";

export const DataRoomRoute = () => {
  useFeatureFlagGuard(
    "gp_co_investment",
    // Only redirect to home when not in GP co-invest portal
    isGPCoInvestPortal ? undefined : CommonPaths.Home,
  );

  const { featureFlag, isLoading } = useFeatureFlag();

  if (isLoading) {
    return (
      <div className="flex justify-center my-16" role="status">
        <LoadingSpinner />
      </div>
    );
  }

  if (featureFlag[FeatureFlag.COINVEST_DATA_ROOM_VD_22599]) {
    return <DataRoomPage />;
  }

  return <DataRoomAndNdaPage />;
};
